<p-button
        #triggerButton
        [attr.data-test]="`${tableKey()}-column-selector-button`"
        variant="outlined"
        [label]="'table.wrapper.columns.placeholder' | transloco"
        aria-haspopup="dialog"
        (onClick)="toggle($event)" />
<p-popover #popover appendTo="body" styleClass="mon-column-selector-popover" (onShow)="onPopoverShow()" (onHide)="onPopoverHide()">
    <div #popoverContent
         pFocusTrap
         class="tw-outline-none tw-flex tw-flex-col tw-gap-2 tw-py-1"
         tabindex="-1"
         (keydown)="onContentKeydown($event)">
        @for (column of columns(); track column.id) {
            <div class="tw-flex tw-items-center tw-gap-2">
                <p-checkbox
                        [value]="column"
                        [(ngModel)]="selectedColumns"
                        [inputId]="tableKey() + '-column-' + column.id"
                        [attr.data-test]="`${tableKey()}-column-${column.id}-checkbox`" />
                <label [for]="tableKey() + '-column-' + column.id">{{ column.label }}</label>
            </div>
        }
    </div>
</p-popover>
